import { NgModule } from '@angular/core';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthModule, OidcSecurityService } from 'angular-auth-oidc-client';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { UiNdmsModule } from 'projects/shared/ui-ndms/ui-ndms.module';
import { UiRmsModule } from 'projects/rms/app/shared/ui-rms/ui-rms.module';
import { HirAppModuleShared } from 'projects/hir/app/app.module.shared';
import { JpatsAppModuleShared } from 'projects/jpats/app/app.module.shared';
import { RmsAppModuleShared } from 'projects/rms/app/app.module.shared';
import { NdmsAuthService } from './shared/core-ndms/services/ndms-auth.service';
import { NdmsAuthenticationGuard } from './shared/core-ndms/services/ndms-authentication.guard';
import { CoreUiModule } from './shared/core-ui/core-ui.module';
import { AppModule, agencyLogo, appEmail, departmentLogo, department, helpEmail, helpIssue, helpLink, helpNumber,
  loginWelcome, program, programSuite, vulnerabilityPolicy, welcome, userGuides } from './app.module.browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ApiModule as SharedApiModule } from 'projects/shared/core/app/api/api.module';
import { ApiModule as HirApiModule } from 'projects/hir/app/api/api.module';
import { ApiModule as JpatsApiModule } from 'projects/jpats/app/api/api.module';
import { ApiModule as RmsApiModule } from 'projects/rms/app/api/api.module';
import { AppSelectComponent } from './components/app-select/app-select.component';
import { ApplicationCardComponent } from './components/home/application-card/application-card.component';
import { ApplicationCardGroupComponent } from './components/home/application-card-group/application-card-group.component';
import { NdmsHomeService } from './components/home/home.service';
import { HomeComponent, GroupApplicationsByPipe } from './components/home/home.component';
import { LogoffTimerComponent } from './components/logoff-timer/logoff-timer.component';
import { UsersModule } from './components/users/users.module';

const url = getBaseUrl();
export function getBaseUrl() {
  let baseurl = document.getElementsByTagName('base')[0].href;
  if(baseurl[baseurl.length - 1] === '/')
    return baseurl.slice(0, -1);
  return baseurl;
}
export const rootUrl = {rootUrl: getBaseUrl()};
const ndmsModule = {
  declarations: [
    AppComponent,
    HomeComponent,
    GroupApplicationsByPipe,
    AppSelectComponent,
    LogoffTimerComponent,
    ApplicationCardComponent,
    ApplicationCardGroupComponent,
  ],
  imports: [
    CommonModule,
    CoreUiModule,
    AppRoutingModule,
    AppModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    UsersModule,
    UiNdmsModule,
    UiRmsModule,
    NgIdleKeepaliveModule.forRoot(),
    AuthModule.forRoot(),
    JpatsAppModuleShared.forRoot(),
    RmsAppModuleShared.forRoot(),
    HirAppModuleShared.forRoot(),
    SharedApiModule.forRoot(rootUrl),
    JpatsApiModule.forRoot(rootUrl),
    RmsApiModule.forRoot(rootUrl),
    HirApiModule.forRoot(rootUrl),
    SimpleNotificationsModule.forRoot()
  ],
  entryComponents:[LogoffTimerComponent],
  providers:[
    OidcSecurityService,
    NdmsAuthService,
    NdmsAuthenticationGuard,
    NdmsHomeService,
    { provide: 'PROGRAM', useFactory: program },
    { provide: 'PROGRAM_SUITE', useFactory: programSuite },
    { provide: 'AGENCY_LOGO', useFactory: agencyLogo },
    { provide: 'DEPARTMENT_LOGO', useFactory: departmentLogo },
    { provide: 'DEPARTMENT', useFactory: department },
    { provide: 'HELP_ISSUE', useFactory: helpIssue },
    { provide: 'HELP_LINK', useFactory: helpLink },
    { provide: 'HELP_EMAIL', useFactory: helpEmail },
    { provide: 'HELP_NUMBER', useFactory: helpNumber },
    { provide: 'APP_EMAIL', useFactory: appEmail },
    { provide: 'WELCOME', useFactory: welcome },
    { provide: 'LOGIN_WELCOME', useFactory: loginWelcome },
    { provide: 'VULNERABILITY_POLICY', useFactory: vulnerabilityPolicy},
    { provide: 'USER_GUIDES', useFactory: userGuides}
  ],
  bootstrap: [AppComponent]
};
@NgModule(ndmsModule)
export class AppModuleShared {}
